<template>
  <div class="moderation-wrapper">
    <div class="container">
      <Title>Image Moderation</Title>
      <div class="card-container">
        <div class="card moderation-list-card">
          <h3>Cases</h3>
          <div class="moderation-case-list-container">
            <ModerationCaseBox v-for="moderation_case in unresolvedCases" :key="moderation_case.id"
                               :created-at="moderation_case.created_at" :image-id="moderation_case.image_id"
                               :reason="moderation_case.reason" @selected="setSelectedCaseId(moderation_case.id)"
            ></ModerationCaseBox>
          </div>
        </div>
        <div class="card moderation-detail-card">
          <p v-if="!selectedCase">Choose a case from the list</p>
          <div v-else class="selected-moderation-case-detail">
            <div class="moderation-case-image-wrapper">
              <img v-if="selectedCaseImageUrl" :src="selectedCaseImageUrl" alt="Case image"
                   class="moderation-case-image"/>
            </div>
            <div>
              <span class="moderation-case-data-label">Reason</span>
              <p class="moderation-case-data-value"> {{ selectedCase.reason }}</p>
            </div>
            <div>
              <span class="moderation-case-data-label">Owner</span>
              <p class="moderation-case-data-value"> {{ selectedCase.image_owner.username }}</p>
            </div>
            <div>
              <span class="moderation-case-data-label">Case ID</span>
              <p class="moderation-case-data-value"> {{ selectedCase.id }}</p>
            </div>
            <div class="moderation-case-detail-buttons">
              <button v-if="!showModerationResultMessage" class="button-primary button-allow"
                      @click="allowModerationCase">Allow
              </button>
              <button v-if="!showModerationResultMessage" class="button-warning button-deny"
                      @click="denyModerationCase">Deny
              </button>
              <p v-if="showModerationResultMessage" class="moderation-case-result"> {{ moderationResultMessage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import Title from "@/components/common/Title.vue";
import {onMounted, ref} from "vue";
import apiService from "@/services/apiService";
import ModerationCaseBox from "@/components/common/ModerationCaseBox.vue";

const unresolvedCases = ref([])
const selectedCase = ref(null);
const selectedCaseImageUrl = ref(null);

const showModerationResultMessage = ref(false);
const moderationResultMessage = ref('');

onMounted(async () => {
  await loadUnresolvedCases();
})

async function setSelectedCaseId(caseId) {
  selectedCase.value = unresolvedCases.value.find(c => c.id === caseId);
  await loadSelectedCaseImageBlob();
}

async function loadUnresolvedCases() {
  unresolvedCases.value = await apiService.getUnresolvedModerationCases();
}

async function loadSelectedCaseImageBlob() {
  const response = await apiService.getImageSignedUrl(selectedCase.value.image_id)
  selectedCaseImageUrl.value = response.url
}

async function denyModerationCase() {
  const response = await apiService.denyModerationCase(selectedCase.value.id);
  if (response.ok) {
    moderationResultMessage.value = response.message;
    showModerationResultMessage.value = true;
    await resetPage();
  }
}

async function allowModerationCase() {
  const response = await apiService.allowModerationCase(selectedCase.value.id);
  if (response.ok) {
    moderationResultMessage.value = response.message;
    showModerationResultMessage.value = true;
    await resetPage();
  }
}

async function resetPage() {
  setTimeout(async () => {
    await loadUnresolvedCases();
    selectedCase.value = null;
    showModerationResultMessage.value = false;
  }, 3000)
}

</script>

<style scoped>

.moderation-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.card-container {
  display: flex;
  width: 100%;
  height: 100%;
  gap: 1rem;
}

.moderation-list-card {
  flex-basis: 60%;
}

.moderation-detail-card {
  flex-basis: 40%;
}

.moderation-case-list-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: start;
  gap: 1rem;
}

.selected-moderation-case-detail {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-content: center;
  gap: 0.8rem;
}

.moderation-case-image-wrapper {
  overflow: hidden;
  border-radius: 10px;
}

.moderation-case-image {
  max-width: 100%;
  border-radius: 10px;
  filter: blur(20px);
  overflow: hidden;
  transition: all 0.1s ease-in-out;
}

.moderation-case-image:hover {
  filter: blur(0px);
}

.moderation-case-data-label {
  font-size: 0.8rem;
  font-weight: lighter;
}

.moderation-case-data-value {
  margin: 0;
}

.moderation-case-detail-buttons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 1rem;
}

.moderation-case-detail-buttons button {
  width: 30%;
  transition: all 0.2s ease-in-out;
}

.button-allow:hover {
  background-color: #244c8a;
}

.button-deny:hover {
  background-color: #b5822c;
}

.moderation-case-result {
  margin: 0;
  background-color: #d1f4b0;
  width: fit-content;
  padding: 0.3rem;
  color: #156100;
  border-radius: 5px;
}

</style>